<template>
    <div>
        <div class="rounded-r bg-white md:hidden flex justify-between w-full p-6 items-center"
            :class="[openNav ? 'hidden' : 'flex']">
            <!--- more free and premium Tailwind CSS components at https://tailwinduikit.com/ --->
            <div class="flex justify-between items-center space-x-3">
                <svg-vue icon="bmb" class="w-10 text-neutral-600"></svg-vue>
            </div>
            <div class="menu-wrapper" @click="openNav = !openNav" :class="{ active: openNav }">
                <div class="menu-bar one"></div>
                <div class="menu-bar two"></div>
            </div>
        </div>
        <div id="Main"
            class="md:rounded-r transform  md:translate-x-0  ease-in-out transition duration-500 flex justify-start items-start h-full  w-full md:w-64 bg-white bg-opacity-50 flex-col md:flex z-[999999] backdrop-blur-3xl"
            :class="[openNav ? 'fixed top-0 left-0' : 'hidden']">
            <a :href="JSON.parse($attrs.menu)['home']"
                class="hidden md:flex justify-start px-4 py-6 items-center space-x-3">
                <svg-vue icon="bmb" class="w-10 text-neutral-600"></svg-vue>
            </a>
            <div class="rounded-r md:hidden flex justify-between w-full p-6 items-center ">
                <!--- more free and premium Tailwind CSS components at https://tailwinduikit.com/ --->
                <div class="flex justify-between items-center space-x-3">
                    <svg-vue icon="bmb" class="w-10 text-neutral-600"></svg-vue>
                </div>
                <div class="menu-wrapper" @click="openNav = !openNav" :class="{ active: openNav }">
                    <div class="menu-bar one"></div>
                    <div class="menu-bar two"></div>
                </div>
            </div>
            <div
                class="mt-6 flex flex-col justify-start items-center  pl-4 w-full border-neutral-200 border-b space-y-3 pb-5 ">
                <a v-if="JSON.parse($attrs.menu)['home']" :href="JSON.parse($attrs.menu)['home']"
                    :class="[$attrs.currenturl == JSON.parse($attrs.menu)['home'] ? '!text-primary': '']"
                    class="flex jusitfy-start items-center space-x-6 w-full py-2 focus:outline-none  focus:text-primary-400 text-neutral-700 rounded ">
                    <svg class="fill-stroke " width="24" height="24" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M9 4H5C4.44772 4 4 4.44772 4 5V9C4 9.55228 4.44772 10 5 10H9C9.55228 10 10 9.55228 10 9V5C10 4.44772 9.55228 4 9 4Z"
                            stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M19 4H15C14.4477 4 14 4.44772 14 5V9C14 9.55228 14.4477 10 15 10H19C19.5523 10 20 9.55228 20 9V5C20 4.44772 19.5523 4 19 4Z"
                            stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M9 14H5C4.44772 14 4 14.4477 4 15V19C4 19.5523 4.44772 20 5 20H9C9.55228 20 10 19.5523 10 19V15C10 14.4477 9.55228 14 9 14Z"
                            stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M19 14H15C14.4477 14 14 14.4477 14 15V19C14 19.5523 14.4477 20 15 20H19C19.5523 20 20 19.5523 20 19V15C20 14.4477 19.5523 14 19 14Z"
                            stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <p class="text-sm leading-4 ">{{ $t("Dashboard") }}</p>
                </a>
                <a v-if="JSON.parse($attrs.menu)['planning']" :href="JSON.parse($attrs.menu)['planning']"
                    :class="[$attrs.currenturl == JSON.parse($attrs.menu)['planning'] ? '!text-primary': '']"
                    class="flex jusitfy-start items-center w-full py-2 space-x-6 focus:outline-none text-neutral-700 focus:text-primary-400   rounded ">
                    <svg-vue icon="cleaning" class="w-5 h-5"></svg-vue>
                    <p class="text-sm leading-4 ">{{ $t('Planning') }}</p>
                </a>
            </div>
            <div v-if="JSON.parse($attrs.menu)['properties'] || JSON.parse($attrs.menu)['rooms'] || JSON.parse($attrs.menu)['prices'] " class="flex flex-col justify-start items-center   px-6 border-b border-neutral-200 w-full">
                <button @click="showMenu('properties')"
                    class="focus:outline-none focus:text-primary-400 text-left  text-neutral-700 flex justify-between items-center w-full py-5 space-x-14  ">
                    <p class="text-sm leading-5">{{ $t("Properties") }}</p>
                    <svg id="icon1" class="transform" :class="[openMenu == 'properties' ? '' : 'rotate-180']" width="24"
                        height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 15L12 9L6 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </button>
                <div class="flex justify-start  flex-col w-full md:w-auto items-start pb-1 "
                    :class="[openMenu == 'properties' ? 'flex' : 'hidden']">
                    <a v-if="JSON.parse($attrs.menu)['properties']" :href="JSON.parse($attrs.menu)['properties']"
                    :class="[$attrs.currenturl == JSON.parse($attrs.menu)['properties'] ? '!text-primary': '']"
                        class="flex justify-start items-center space-x-6 hover:text-neutral-700 focus:bg-neutral-100 focus:text-neutral-700 hover:bg-neutral-100 text-gray-400 rounded px-3 py-2  w-full md:w-52">
                        <svg-vue icon="house" class="w-5 h-5"></svg-vue>
                        <p class="text-sm leading-4  ">{{ $t("Properties") }}</p>
                    </a>
                    <a v-if="JSON.parse($attrs.menu)['rooms']" :href="JSON.parse($attrs.menu)['rooms']"
                    :class="[$attrs.currenturl == JSON.parse($attrs.menu)['rooms'] ? '!text-primary': '']"
                        class="flex justify-start items-center space-x-6 hover:text-neutral-700 focus:bg-neutral-100 focus:text-neutral-700 hover:bg-neutral-100 text-gray-400 rounded px-3 py-2  w-full md:w-52">
                        <svg-vue icon="bed" class="w-5 h-5"></svg-vue>
                        <p class="text-sm leading-4  ">{{ $t("Rooms") }}</p>
                    </a>
                    <a v-if="JSON.parse($attrs.menu)['prices']" :href="JSON.parse($attrs.menu)['prices']"
                    :class="[$attrs.currenturl == JSON.parse($attrs.menu)['prices'] ? '!text-primary': '']"
                        class="flex justify-start items-center space-x-6 hover:text-neutral-700 focus:bg-neutral-100 focus:text-neutral-700 hover:bg-neutral-100 text-gray-400 rounded px-3 py-2 w-full md:w-52">
                        <svg-vue icon="money" class="w-5 h-5"></svg-vue>
                        <p class="text-sm leading-4  ">{{ $t("Prices") }}</p>
                    </a>
                </div>
            </div>
            <div v-if="JSON.parse($attrs.menu)['news'] || JSON.parse($attrs.menu)['events'] || JSON.parse($attrs.menu)['locations'] || JSON.parse($attrs.menu)['media'] ||JSON.parse($attrs.menu)['categories'] || JSON.parse($attrs.menu)['promotions']" class="flex flex-col justify-start px-6 border-b border-neutral-200 w-full">
                <button @click="showMenu('resources')"
                    class="focus:outline-none focus:text-primary-400  text-neutral-700 flex justify-between items-center w-full py-5 space-x-14  ">
                    <p class="text-sm leading-5">{{ $t("Resources") }}</p>
                    <svg id="icon2" class="transform" :class="[openMenu == 'resources' ? '' : 'rotate-180']" width="24"
                        height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 15L12 9L6 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </button>
                <div class="flex justify-start flex-col items-start pb-5"
                    :class="[openMenu == 'resources' ? 'flex' : 'hidden']">
                    <a v-if="JSON.parse($attrs.menu)['news']"  :href="JSON.parse($attrs.menu)['news']"
                    :class="[$attrs.currenturl == JSON.parse($attrs.menu)['news'] ? '!text-primary': '']"
                        class="flex justify-start items-center space-x-6 hover:text-neutral-700 focus:bg-neutral-100 focus:text-neutral-700 hover:bg-neutral-100 text-gray-400 rounded px-3 py-2  w-full md:w-52">
                        <svg-vue icon="news" class="w-5 h-5"></svg-vue>
                        <p class="text-sm leading-4  ">{{ $t("News") }}</p>
                    </a>
                    <a v-if="JSON.parse($attrs.menu)['events']" :href="JSON.parse($attrs.menu)['events']"
                    :class="[$attrs.currenturl == JSON.parse($attrs.menu)['events'] ? '!text-primary': '']"
                        class="flex justify-start items-center space-x-6 hover:text-neutral-700 focus:bg-neutral-100 focus:text-neutral-700 hover:bg-neutral-100 text-gray-400 rounded px-3 py-2  w-full md:w-52">
                        <svg-vue icon="event" class="w-5 h-5"></svg-vue>
                        <p class="text-sm leading-4  ">{{ $t("Events") }}</p>
                    </a>
                    <a v-if="JSON.parse($attrs.menu)['locations']" :href="JSON.parse($attrs.menu)['locations']"
                    :class="[$attrs.currenturl == JSON.parse($attrs.menu)['locations'] ? '!text-primary': '']"
                        class="flex justify-start items-center space-x-6 hover:text-neutral-700 focus:bg-neutral-100 focus:text-neutral-700 hover:bg-neutral-100 text-gray-400 rounded px-3 py-2  w-full md:w-52">
                        <svg-vue icon="location" class="w-5 h-5"></svg-vue>
                        <p class="text-sm leading-4  ">{{ $t("Locations") }}</p>
                    </a>
                    <a v-if="JSON.parse($attrs.menu)['categories']" :href="JSON.parse($attrs.menu)['categories']"
                    :class="[$attrs.currenturl == JSON.parse($attrs.menu)['categories'] ? '!text-primary': '']"
                        class="flex justify-start items-center space-x-6 hover:text-neutral-700 focus:bg-neutral-100 focus:text-neutral-700 hover:bg-neutral-100 text-gray-400 rounded px-3 py-2 w-full md:w-52">
                        <svg-vue icon="layers" class="w-5 h-5"></svg-vue>
                        <p class="text-sm leading-4  ">{{ $t("Categories") }}</p>
                    </a>
                    <a v-if="JSON.parse($attrs.menu)['media']" :href="JSON.parse($attrs.menu)['media']"
                    :class="[$attrs.currenturl == JSON.parse($attrs.menu)['media'] ? '!text-primary': '']"
                        class="flex justify-start items-center space-x-6 hover:text-neutral-700 focus:bg-neutral-100 focus:text-neutral-700 hover:bg-neutral-100 text-gray-400 rounded px-3 py-2  w-full md:w-52">
                        <svg-vue icon="photo-film" class="w-5 h-5"></svg-vue>
                        <p class="text-sm leading-4  ">{{ $t("Media") }}</p>
                    </a>
                    <a v-if="JSON.parse($attrs.menu)['promotions']" :href="JSON.parse($attrs.menu)['promotions']"
                    :class="[$attrs.currenturl == JSON.parse($attrs.menu)['promotions'] ? '!text-primary': '']"
                        class="flex justify-start items-center space-x-6 hover:text-neutral-700 focus:bg-neutral-100 focus:text-neutral-700 hover:bg-neutral-100 text-gray-400 rounded px-3 py-2  w-full md:w-52">
                        <svg-vue icon="crown" class="w-5 h-5"></svg-vue>
                        <p class="text-sm leading-4  ">{{ $t("Promotions") }}</p>
                    </a>
                </div>
            </div>
            <div  v-if="JSON.parse($attrs.menu)['bookings']"  class="flex flex-col justify-between pb-6 px-6 w-full">
                <button @click="showMenu('bookings')"
                    class="focus:outline-none focus:text-primary-400  text-neutral-700 flex justify-between items-center w-full py-5 space-x-14  ">
                    <p class="text-sm leading-5">{{ $t("Bookings") }}</p>
                    <svg id="icon2" class="transform" :class="[openMenu == 'bookings' ? '' : 'rotate-180']" width="24"
                        height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 15L12 9L6 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </button>
                <div class="flex justify-start flex-col items-start pb-5"
                    :class="[openMenu == 'bookings' ? 'flex' : 'hidden']">
                    <a  v-if="JSON.parse($attrs.menu)['bookings']"  :href="JSON.parse($attrs.menu)['bookings']"
                    :class="[$attrs.currenturl == JSON.parse($attrs.menu)['bookings'] ? '!text-primary': '']"
                        class="flex justify-start items-center space-x-6 hover:text-neutral-700 focus:bg-neutral-100 focus:text-neutral-700 hover:bg-neutral-100 text-gray-400 rounded px-3 py-2  w-full md:w-52">
                        <svg-vue icon="list" class="w-5 h-5"></svg-vue>
                        <p class="text-sm leading-4  ">{{ $t("Bookings") }}</p>
                    </a>
                </div>
            </div>
            <div class=" flex flex-col justify-between items-center w-full mt-auto  pb-6 px-6 ">
                <div class="flex justify-start flex-col items-start pb-5"
                    :class="[openMenu == 'settings' ? 'flex' : 'hidden']">
                    <a  v-if="JSON.parse($attrs.menu)['users']"  :href="JSON.parse($attrs.menu)['users']"
                    :class="[$attrs.currenturl == JSON.parse($attrs.menu)['users'] ? '!text-primary': '']"
                        class="flex justify-start items-center space-x-6 hover:text-neutral-700 focus:bg-neutral-100 focus:text-neutral-700 hover:bg-neutral-100 text-gray-400 rounded px-3 py-2  w-full md:w-52">
                        <svg-vue icon="users" class="w-5 h-5"></svg-vue>
                        <p class="text-sm leading-4  ">{{ $t("Users") }}</p>
                    </a>
                    <a  v-if="JSON.parse($attrs.menu)['logwork']"  :href="JSON.parse($attrs.menu)['logwork']"
                    :class="[$attrs.currenturl == JSON.parse($attrs.menu)['logwork'] ? '!text-primary': '']"
                        class="flex justify-start items-center space-x-6 hover:text-neutral-700 focus:bg-neutral-100 focus:text-neutral-700 hover:bg-neutral-100 text-gray-400 rounded px-3 py-2  w-full md:w-52">
                        <svg-vue icon="clock" class="w-5 h-5"></svg-vue>
                        <p class="text-sm leading-4  ">{{ $t("Logged Work") }}</p>
                    </a>
                    <!-- <button
                        class="flex justify-start items-center space-x-6 hover:text-neutral-700 focus:bg-neutral-100 focus:text-neutral-700 hover:bg-neutral-100 text-gray-400 rounded px-3 py-2  w-full md:w-52">
                        <svg-vue icon="mug" class="w-5 h-5"></svg-vue>
                        <p class="text-sm leading-4  ">{{ $t("Clients") }}</p>
                    </button>
                    <button
                        class="flex justify-start items-center space-x-6 hover:text-neutral-700 focus:bg-neutral-100 focus:text-neutral-700 hover:bg-neutral-100 text-gray-400 rounded px-3 py-2  w-full md:w-52">
                        <svg-vue icon="bullseye" class="w-5 h-5"></svg-vue>
                        <p class="text-sm leading-4  ">{{ $t("Webhook logs") }}</p>
                    </button>
                    <button
                        class="flex justify-start items-center space-x-6 hover:text-neutral-700 focus:bg-neutral-100 focus:text-neutral-700 hover:bg-neutral-100 text-gray-400 rounded px-3 py-2  w-full md:w-52">
                        <svg-vue icon="scape" class="w-5 h-5"></svg-vue>
                        <p class="text-sm leading-4  ">{{ $t("prop API keys") }}</p>
                    </button>
                    <button
                        class="flex justify-start items-center space-x-6 hover:text-neutral-700 focus:bg-neutral-100 focus:text-neutral-700 hover:bg-neutral-100 text-gray-400 rounded px-3 py-2  w-full md:w-52">
                        <svg-vue icon="wifi" class="w-5 h-5"></svg-vue>
                        <p class="text-sm leading-4  ">{{ $t("Connections") }}</p>
                    </button>
                    <button
                        class="flex justify-start items-center space-x-6 hover:text-neutral-700 focus:bg-neutral-100 focus:text-neutral-700 hover:bg-neutral-100 text-gray-400 rounded px-3 py-2  w-full md:w-52">
                        <svg-vue icon="tv" class="w-5 h-5"></svg-vue>
                        <p class="text-sm leading-4  ">{{ $t("Channels") }}</p>
                    </button> -->
                </div>
                <button @click="showMenu('settings')" class="flex justify-between items-center w-full ">
                    <div class="flex justify-center items-center  space-x-2">
                        <div>
                            <gravatar class="h-10 w-10 rounded-full object-cover" :email="JSON.parse($attrs.user).email">
                            </gravatar>
                        </div>
                        <div class="flex justify-start flex-col items-start">
                            <p class="cursor-pointer text-sm leading-5 text-neutral-700">{{
                                JSON.parse($attrs.user).first_name }}</p>
                        </div>
                    </div>
                    <svg-vue icon="settings" class="w-5 h-5 transition"
                        :class="[openMenu == 'settings' ? 'rotate-45' : '']"></svg-vue>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import $ from 'jquery'

export default {
    components: {
        draggable,
    },

    data() {
        return {
            openMenu: null,
            openNav: false
        };
    },

    mounted() {
        if (this.$attrs.currenturl) {
            var menu = JSON.parse(this.$attrs.menu);
            switch(this.$attrs.currenturl) {
                case menu['properties']:
                case menu['rooms']:
                case menu['prices']:
                    this.openMenu = 'properties'
                    break;
                case menu['news']:
                case menu['events']:
                case menu['locations']:
                case menu['categories']:
                case menu['promotions']:
                    this.openMenu = 'resources'
                    break;
                case menu['bookings']:
                    this.openMenu = 'bookings'
                    break;
                case menu['users']:
                    this.openMenu = 'settings'
                    break;
                default:
                    console.log(`nomenu`);
            }
        }
    },

    methods: {
        showMenu(menu) {
            if (menu == this.openMenu) {
                this.openMenu = null;
            } else {
                this.openMenu = menu;
            }
        }
    }
}

</script>